import React from 'react';
import { Box } from '@mui/material';

export interface TabPanelComponentProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  padding?: number | string;
  id?: string;
}

/**
 * TabPanelComponent - Reusable Tab Panel Component
 *
 * A standardized tab panel component that provides:
 * - Proper accessibility attributes for screen readers
 * - Conditional rendering based on active tab
 * - Customizable padding and styling
 * - Consistent behavior across tabbed interfaces
 */
export const TabPanelComponent: React.FC<TabPanelComponentProps> = ({
  children,
  value,
  index,
  padding = 3,
  id,
  ...other
}) => {
  const panelId = id || `simple-tabpanel-${index}`;
  const labelledBy = `simple-tab-${index}`;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={panelId}
      aria-labelledby={labelledBy}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: padding }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanelComponent;